import React, { useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import Header from '../components/Header';
import { useLanguage } from '../context/LanguageContext';

const getApiUrl = () => {
  const hostname = window.location.hostname.toLowerCase();
  const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1' || hostname.includes('localhost');
  return isLocalhost ? 'http://localhost:5000' : 'https://orders.fletaime.com';
};

const WHATSAPP_PHONE = '38345937644';

export default function OrderCancel() {
  const { t } = useLanguage();
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get('order');
  const [retrying, setRetrying] = useState(false);
  const [error, setError] = useState(null);

  // Photos and the order record were already saved before payment started -
  // retrying only needs to open a fresh Stripe Checkout Session for the same
  // order, using the price already stored on it, not a full resubmission.
  const handleRetry = async () => {
    if (!orderId) return;
    setRetrying(true);
    setError(null);
    try {
      const API_URL = getApiUrl();
      const infoRes = await fetch(`${API_URL}/order-info/${orderId}`);
      const infoData = await infoRes.json();
      const amount = infoData.order?.price;
      if (!amount) throw new Error(t('cancel.orderNotFound'));

      const checkoutRes = await fetch(`${API_URL}/payment/create-checkout-session`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ supabaseOrderId: orderId, amount, currency: 'eur' }),
      });
      const checkoutData = await checkoutRes.json();
      if (!checkoutRes.ok || !checkoutData.success || !checkoutData.url) {
        throw new Error(checkoutData.message || t('cancel.genericError'));
      }
      window.location.href = checkoutData.url;
    } catch (err) {
      setError(err.message || t('cancel.retryError'));
      setRetrying(false);
    }
  };

  const contactOnWhatsapp = () => {
    const message = t('wa.cancel.message', { id: orderId });
    const url = `https://api.whatsapp.com/send?phone=${WHATSAPP_PHONE}&text=${encodeURIComponent(message)}`;
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="order-form-page">
      <Header />
      <div style={{ maxWidth: '560px', margin: '60px auto', padding: '32px 24px', textAlign: 'center' }}>
        <div style={{ fontSize: '56px', marginBottom: '16px' }}>😕</div>
        <h1 style={{ marginBottom: '12px' }}>{t('cancel.title')}</h1>
        <p style={{ color: '#555', marginBottom: '24px' }}>
          {t('cancel.desc', { id: orderId })}
        </p>

        {error && (
          <p style={{ color: '#e53e3e', marginBottom: '16px' }}>{error}</p>
        )}

        <button
          onClick={handleRetry}
          disabled={retrying || !orderId}
          style={{
            display: 'inline-block',
            background: '#2d3748',
            color: 'white',
            border: 'none',
            padding: '14px 28px',
            borderRadius: '8px',
            fontWeight: 'bold',
            fontSize: '15px',
            cursor: retrying ? 'not-allowed' : 'pointer',
            opacity: retrying ? 0.6 : 1,
            marginBottom: '12px',
            marginRight: '10px',
          }}
        >
          {retrying ? t('cancel.retrying') : t('cancel.retryBtn')}
        </button>

        <button
          onClick={contactOnWhatsapp}
          disabled={!orderId}
          style={{
            display: 'inline-block',
            background: '#25D366',
            color: 'white',
            border: 'none',
            padding: '14px 28px',
            borderRadius: '8px',
            fontWeight: 'bold',
            fontSize: '15px',
            cursor: 'pointer',
            marginBottom: '16px',
          }}
        >
          {t('cancel.contactBtn')}
        </button>

        <div>
          <Link to="/" style={{ color: '#2d3748', textDecoration: 'underline' }}>{t('success.backHome')}</Link>
        </div>
      </div>
    </div>
  );
}
